
import Vue from "vue";
import { FolderUser } from "../../models/tasks/folder-user";
import AppCalendarListItem from "./CalendarListItem.vue";

export default Vue.extend({
	props: {
		folder: {
			type: Object as ()=>FolderUser,
			required: true,
		},
		active: Boolean,
	},
	methods: {
		load(){
			this.$emit("load");
		}
	},
	components: {
		AppCalendarListItem
	}
});
